import { HelpDrawerAnalytics } from "./HelpDrawerWrapper";
import { Dispatch } from "react";
import {
  AnalyticsActions,
  AnalyticsActionType,
  Ga4Event,
} from "../app/contexts/Analytics/types";

export const newBasicHelperDrawerAnalytics = ({
  clickText,
  dispatch,
}: {
  clickText: string;
  dispatch: Dispatch<AnalyticsActions>;
}): HelpDrawerAnalytics => {
  return {
    openDrawer: () => {
      dispatch({
        type: AnalyticsActionType.SEND_TEALIUM_EVENT,
        settings: {
          event_action: "Help drawer",
          event_label: "opened",
        },
      });
      dispatch({
        type: AnalyticsActionType.SEND_GA4_EVENT,
        settings: {
          event_name: Ga4Event.HELP_DRAWER_OPENED,
          click_text: clickText,
        },
      });
    },
    closeDrawer: () => {
      dispatch({
        type: AnalyticsActionType.SEND_TEALIUM_EVENT,
        settings: {
          event_action: "Help drawer",
          event_label: "closed",
        },
      });
      dispatch({
        type: AnalyticsActionType.SEND_GA4_EVENT,
        settings: {
          event_name: Ga4Event.HELP_DRAWER_CLOSED,
          click_text: clickText,
        },
      });
    },
  };
};
